@let options = (filteredOptions$ | async) ?? [];

<div [formGroup]="form">
  <div class="relative w-full">
    <div
      #trigger="matMenuTrigger"
      [matMenuTriggerFor]="countryMenu"
      class="absolute inset-0 pointer-events-none"></div>
    <mat-form-field
      class="w-full"
      subscriptSizing="dynamic">
      <div
        matPrefix
        class="flex items-center gap-1 pl-4">
        <button
          (click)="trigger.openMenu()"
          [attr.aria-expanded]="trigger.menuOpen"
          (keydown.enter)="trigger.openMenu(); $event.preventDefault()"
          (keydown.space)="trigger.openMenu(); $event.preventDefault()"
          [disabled]="form.disabled"
          aria-haspopup="menu"
          type="button">
          <div class="flex items-center gap-1">
            <rms-flag-icon
              class="w-[24px]"
              [countryCode]="form.controls.country.value" />
            <mat-icon
              class="!h-4 !w-4 transition-transform duration-200"
              [class.rotate-180]="trigger.menuOpen"
              svgIcon="remix:Arrows/arrow-down-s-fill" />
          </div>
        </button>
        <span>+{{ form.controls.countryCallingCode.value }}</span>
      </div>
      <input
        formControlName="nationalNumber"
        matInput
        type="text"
        class="text-base"
        rmsInputMask
        [mask]="phoneMask"
        [placeholder]="form.controls.nationalNumberExample.value ?? DEFAULT_PHONE_EXAMPLE"
        autocomplete="off" />
    </mat-form-field>
    <mat-menu
      class="min-w-[240px] sm:min-w-[280px] w-full"
      #countryMenu="matMenu"
      yPosition="below"
      xPosition="after">
      <mat-form-field
        class="sticky top-0 left-0 form-sm w-full mb-2"
        (click)="$event.stopPropagation()"
        subscriptSizing="dynamic">
        <input
          matInput
          type="text"
          formControlName="countryInput" />
      </mat-form-field>

      @if (options.length === 0) {
        <div
          [disabled]="true"
          mat-menu-item>
          <mat-icon
            class="icon-sm"
            svgIcon="remix:Business/flag-fill" />
          <span translate>libs.common.no-results</span>
        </div>
      } @else {
        <cdk-virtual-scroll-viewport
          itemSize="40"
          minBufferPx="200"
          maxBufferPx="400"
          class="h-[180px] overflow-x-hidden">
          <button
            mat-menu-item
            *cdkVirtualFor="let option of options"
            (click)="onCountryChange(option)">
            <div class="flex items-center gap-2 w-[190px] sm:w-[235px]">
              <rms-flag-icon
                class="w-[24px]"
                [width]="24"
                [countryCode]="option.code" />
              <span class="w-full truncate">
                {{ "[+" + option.countryCallingCode + "] " + option.name }}
              </span>
            </div>
          </button>
        </cdk-virtual-scroll-viewport>
      }
    </mat-menu>
  </div>
</div>
